import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';
import AuthClassicLayout from 'src/layouts/auth/classic';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// JWT
const TermsAndConditions = lazy(() => import('src/pages/publics/terms-and-conditions'));
const PrivacyPolicy = lazy(() => import('src/pages/publics/privacy-policy'));
const Edocuments = lazy(() => import('src/pages/publics/e-documents'));
const HelpTutorials = lazy(()=> import('src/pages/publics/help-page'))

// ----------------------------------------------------------------------

const publics = {
  path: 'publics',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: 'terms-and-conditions',
      element: (
        <GuestGuard>
            <TermsAndConditions />
        </GuestGuard>
      ),
    },
    {
      path: 'privacy-policy',
      element: (
        <GuestGuard>
            <PrivacyPolicy />
        </GuestGuard>
      ),
    },
    {
      // Comprobante publico: se ve con o sin sesion (el GuestGuard mandaba al dashboard a los usuarios logueados)
      path: 'documents',
      element: <Edocuments />,
    },
    {
      path: 'tutoriales',
      element: (
        // <GuestGuard>
            <HelpTutorials />
        // </GuestGuard>
      ),
    },
  ],
};

export const publicsRoutes = [
  {
    path: 'info',
    children: [publics],
  },
];
